var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jdl-full-screen container-404"},[_c('div',{staticClass:"pic-404"},[_c('div',{staticClass:"pic-404-bg"}),_c('el-button',{staticClass:"go-home",attrs:{"type":"primary"},on:{"click":_vm.routerback}},[_vm._v(" 返回 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }